import type { SchemaField } from '@cli-types/core-engine/schema.js'
import { assertSupportedSchemaFieldType } from './assert-supported-schema-field-type.js'
import { getTabSlotFields } from './get-tab-slot-fields.js'

export function assertSupportedSchemaFieldTree(field: SchemaField): void {
  assertSupportedSchemaFieldType(field)
  if (field.fields) {
    for (const nestedField of field.fields) {
      assertSupportedSchemaFieldTree(nestedField)
    }
  }
  if (field.items) {
    assertSupportedSchemaFieldTree(field.items as SchemaField)
  }
  if (field.tabs) {
    for (const tab of field.tabs) {
      for (const nestedField of tab.fields || []) {
        assertSupportedSchemaFieldTree(nestedField)
      }
      for (const nestedField of getTabSlotFields(tab.slot)) {
        assertSupportedSchemaFieldTree(nestedField)
      }
    }
  }
}
